import { currentIdCompany } from "../utils/userLS";
const withPrefix = (key: unknown[]) => {
    const idCompany = currentIdCompany();
    return [idCompany, ...key];
};

export default withPrefix;